<template>
  <div class="columns">
    <div class="column">
<!--      <rte-->
<!--        :content="(item.contentable.text) ? item.contentable.text : ''"-->
<!--        @contentChange="set"-->
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Rte from '@/components/modules/Rte'

export default {
  name: 'EditLibraryText',

  // components: {Rte},

  computed: {
    ...mapGetters({
      item: 'library/item'
    })
  },

  methods: {
    set (text) {
      this.$store.commit('library/SET', { key: 'text', value: text })
    },
  }
}
</script>

<style scoped>

</style>
